const INITIAL_STATE = {
  data: {},
  errors: {},
        
}
const getExpiredCard = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_EXPIRED_CARD_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_EXPIRED_CARD_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default getExpiredCard;